import { areBitsSet } from '@helpers/utils.js'
import {
  GAME_COMMUNITY_ALLOW_GUIDE_COMMENTS_TO_BE_DOWNVOTED,
  GAME_COMMUNITY_ALLOW_MOD_COMMENTS_TO_BE_DOWNVOTED,
  MOD_COMMUNITY_ALLOW_MOD_USE_IN_COLLECTIONS,
  GAME_COMMUNITY_ALLOW_COLLECTION_COMMENTS,
  GAME_COMMUNITY_ALLOW_NEGATIVE_RATINGS,
  GAME_COMMUNITY_ALLOW_UGC_PERMISSIONS,
  GAME_COMMUNITY_ALLOW_GUIDE_COMMENTS,
  GAME_COMMUNITY_ALLOW_EDITS_VIA_WEB,
  GAME_COMMUNITY_ALLOW_MOD_COMMENTS,
  GAME_COMMUNITY_ALLOW_MOD_PREVIEW,
  GAME_COMMUNITY_ALLOW_COLLECTIONS,
  ALLOW_REPACKAGE_WITH_PERMISSION,
  GUIDE_COMMUNITY_ALLOW_COMMENTS,
  ALLOW_PATCHING_WITH_PERMISSION,
  MOD_COMMUNITY_ALLOW_DEPENDENCY,
  MOD_COMMUNITY_ALLOW_COMMENTS,
  ORIGINAL_OR_PERMITTED_ASSETS,
  ALLOW_REPACKAGE_WITH_CREDIT,
  ALLOW_PATCHING_WITH_CREDIT,
  ALLOW_REPACKAGE_NO_CREDIT,
  API_AUTHORISED_DOWNLOADS,
  ALLOW_PATCHING_NO_CREDIT,
  ALLOW_USERS_TO_RESELL,
  CURATION_COLLECTIONS,
  ALLOW_REDISTRIBUTION,
  API_DIRECT_DOWNLOAD,
  API_PAID_DOWNLOADS,
  COMMENT_SCRUBBED,
  COMMENT_PINNED,
  COMMENT_LOCKED,
  CURATION_PAID,
  CURATION_FULL,
  CURATION_MODS,
  ALLOW_PORTING,
  SHOW_CREDITS,
} from '@config/options.js'
import {
  MONETIZATION_WEB_DISABLE_SELF_REFUNDS,
  MONETIZATION_PARTNER_PROGRAM_PREVIEW,
  MONETIZATION_MARKETPLACE_ENABLED_MOD,
  MONETIZATION_MARKETPLACE_TOKEN,
  MONETIZATION_MARKETPLACE_USD,
  MONETIZATION_SCARCITY,
  MONETIZATION_ENABLED,
} from '@config/monetization.js'

export function allowDirectDownloads(bits) {
  return areBitsSet(bits, API_DIRECT_DOWNLOAD)
}

export function allowNegativeRatings(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_NEGATIVE_RATINGS)
}

export function restrictDownloadsAuth(bits) {
  return areBitsSet(bits, API_AUTHORISED_DOWNLOADS)
}

export function restrictDownloadsPaid(bits) {
  return areBitsSet(bits, API_PAID_DOWNLOADS)
}

export function isCommentPinned(bits) {
  return areBitsSet(bits, COMMENT_PINNED)
}

export function isCommentLocked(bits) {
  return areBitsSet(bits, COMMENT_LOCKED)
}

export function isCommentScrubbed(bits) {
  return areBitsSet(bits, COMMENT_SCRUBBED)
}

export function allowGameModComments(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_MOD_COMMENTS)
}

export function allowGameGuideComments(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_GUIDE_COMMENTS)
}

export function allowModComments(bits) {
  return areBitsSet(bits, MOD_COMMUNITY_ALLOW_COMMENTS)
}

export function allowModDependency(bits) {
  return areBitsSet(bits, MOD_COMMUNITY_ALLOW_DEPENDENCY)
}

export function allowModInCollections(bits) {
  return areBitsSet(bits, MOD_COMMUNITY_ALLOW_MOD_USE_IN_COLLECTIONS)
}

export function isMonetizationEnabled(bits) {
  return areBitsSet(bits, MONETIZATION_ENABLED)
}

export function isGameCurationPaid(bits) {
  return areBitsSet(bits, CURATION_PAID)
}

export function isGameCurationFull(bits) {
  return areBitsSet(bits, CURATION_FULL, true)
}

export function isGameCurationMods(bits) {
  return areBitsSet(bits, CURATION_MODS, true)
}

export function isGameCurationCollections(bits) {
  return areBitsSet(bits, CURATION_COLLECTIONS, true)
}

export function isMarketplaceEnabledForMod(bits) {
  return areBitsSet(bits, MONETIZATION_MARKETPLACE_ENABLED_MOD)
}

export function isTokenMarketplaceEnabled(bits) {
  return areBitsSet(bits, MONETIZATION_MARKETPLACE_TOKEN)
}

export function isUSDMarketplaceEnabled(bits) {
  return areBitsSet(bits, MONETIZATION_MARKETPLACE_USD)
}

export function isScarcityEnabled(bits) {
  return areBitsSet(bits, MONETIZATION_SCARCITY)
}

export function isMonetizationWebSelfRefundsDisabled(bits) {
  return areBitsSet(bits, MONETIZATION_WEB_DISABLE_SELF_REFUNDS)
}

export function isMonetizationPartnerProgramPreviewEnabled(bits) {
  return areBitsSet(bits, MONETIZATION_PARTNER_PROGRAM_PREVIEW)
}

export function isEditableOnWeb(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_EDITS_VIA_WEB)
}

export function allowGuideComments(bits) {
  return areBitsSet(bits, GUIDE_COMMUNITY_ALLOW_COMMENTS)
}

export function isShowCredits(bits) {
  return areBitsSet(bits, SHOW_CREDITS)
}

export function isOriginalOrPermittedAssets(bits) {
  return areBitsSet(bits, ORIGINAL_OR_PERMITTED_ASSETS)
}

export function allowRedistribution(bits) {
  return areBitsSet(bits, ALLOW_REDISTRIBUTION)
}

export function allowPorting(bits) {
  return areBitsSet(bits, ALLOW_PORTING)
}

export function allowPatchingNoCredit(bits) {
  return areBitsSet(bits, ALLOW_PATCHING_NO_CREDIT)
}

export function allowPatchingWithCredit(bits) {
  return areBitsSet(bits, ALLOW_PATCHING_WITH_CREDIT)
}

export function allowPatchingWithPermission(bits) {
  return areBitsSet(bits, ALLOW_PATCHING_WITH_PERMISSION)
}

export function allowRepackageNoCredit(bits) {
  return areBitsSet(bits, ALLOW_REPACKAGE_NO_CREDIT)
}

export function allowRepackageWithCredit(bits) {
  return areBitsSet(bits, ALLOW_REPACKAGE_WITH_CREDIT)
}

export function allowRepackageWithPermission(bits) {
  return areBitsSet(bits, ALLOW_REPACKAGE_WITH_PERMISSION)
}

export function allowUsersToResell(bits) {
  return areBitsSet(bits, ALLOW_USERS_TO_RESELL)
}

export function allowUgcPermissions(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_UGC_PERMISSIONS)
}

export function allowDownvoteModComments(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_MOD_COMMENTS_TO_BE_DOWNVOTED)
}

export function allowDownvoteGuideComments(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_GUIDE_COMMENTS_TO_BE_DOWNVOTED)
}

export function allowGameModPreviews(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_MOD_PREVIEW)
}

export function areCollectionCommentsAllowed(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_COLLECTION_COMMENTS)
}

export function allowCollections(bits) {
  return areBitsSet(bits, GAME_COMMUNITY_ALLOW_COLLECTIONS)
}

export function disableGameFeaturedCarousels() {
  return false
}
